$(document).ready(function () {
    "use strict";

    var compPCCShopSearch = $('.comp-pcc-shop-search');

    if (compPCCShopSearch.length > 0) {
        pccShopSearch();
    }

    function pccShopSearch() {
        var dropdown = false;
        var focusableEls = $('.comp-pcc-shop-search .custom-select ul li a');
        var firstFocusableEl = focusableEls[0];
        var lastFocusableEl = focusableEls[focusableEls.length - 1];
        var focusedEl = false;

        //Dropdown functionality
        $('.comp-pcc-shop-search .custom-select .selected, .comp-pcc-shop-search .custom-select .icon-arrow').on({
            click: function (event) {
                dropdownClick(event);
            },

            keydown: function (event) {
                var key = event.which;

                if (key === 13 || key === 32) { //enter or space
                    dropdownClick(event);
                    event.preventDefault();
                }

                if (key === 27) { //escape
                    hideDropdown(event);
                    $('.comp-pcc-shop-search .selected').focus();
                }

                if (key === 38) { //up arrow
                    event.preventDefault();
                    if (!dropdown) {
                        showDropdown(event);
                    }
                    focusPrevious();
                }

                if (key === 40) { //down arrow
                    event.preventDefault();
                    if (!dropdown) {
                        showDropdown();
                    }
                    focusNext();
                }

                if (key === 9) { //tab
                    if (dropdown) {
                        if (event.shiftKey) {
                            event.preventDefault();
                            focusPrevious();
                        } else {
                            event.preventDefault();
                            focusNext();
                        }
                    }
                }
            }
        });

        //Hide dropdown with click outside of it
        $(document).click(function () {
            //$('.comp-pcc-shop-search .custom-select ul').slideUp();
            //$('.comp-pcc-shop-search .custom-select i').removeClass('open');

            if ($(event.target).closest('.comp-pcc-shop-search .custom-select').length < 1) {
                hideDropdown();
                //console.log('Docuemnt click NOT inside dropdown.');
            }
        });

        //Dropdown links functionality
        $('.comp-pcc-shop-search .custom-select ul a').on({
            click: function () {
                $(this).parents('.custom-select').find('.selected').text($(this).text());
                var dataValue = $(this).parent().attr('data-value');
                $(this).parents('#groupDistanceDrpDwn').find('#distanceValue').attr('value', dataValue);
                hideDropdown();
                $('.comp-pcc-shop-search .selected').focus();
            },

            keydown: function (event) {
                var key = event.which;

                if (key === 13 || key === 32) { //enter or space
                    $(event.target).trigger('click');
                    event.preventDefault();
                }

                if (key === 27) { //escape
                    hideDropdown();
                    $('.comp-pcc-shop-search .selected').focus();
                }

                if (key === 38) { //up arrow
                    event.preventDefault();
                    focusPrevious();
                }

                if (key === 40) { //down arrow
                    event.preventDefault();
                    focusNext();
                }

                if (key === 9) { //tab
                    if (event.shiftKey) {
                        event.preventDefault();
                        focusPrevious();
                    } else {
                        event.preventDefault();
                        focusNext();
                    }
                }
            }
        });

        function dropdownClick(event) {
            $(event.target).parent().find('ul').slideToggle();
            $(event.target).parent().find('.icon-arrow').toggleClass('open');
            dropdown = !dropdown;
        }

        function hideDropdown() {
            $('.comp-pcc-shop-search .custom-select').find('ul').slideUp();
            $('.comp-pcc-shop-search .custom-select').find('.icon-arrow').removeClass('open');
            $('.comp-pcc-shop-search .selected').attr('aria-expanded', 'false');
            dropdown = false;
            focusedEl = false;
        }

        function showDropdown() {
            $('.comp-pcc-shop-search .custom-select').find('ul').slideDown();
            $('.comp-pcc-shop-search .custom-select').find('.icon-arrow').addClass('open');
            $('.comp-pcc-shop-search .selected').attr('aria-expanded', 'true');
            dropdown = true;
        }

        function focusNext() {
            if (!focusedEl) {
                firstFocusableEl.focus();
                focusedEl = 1;
                //console.log('First element focused');
            } else if (focusedEl === focusableEls.length) {
                firstFocusableEl.focus();
                focusedEl = 1;
                //console.log('First element focused from last element');
            } else {
                focusableEls[focusedEl].focus();
                focusedEl++;
                //console.log('Next element focused');
            }
            //console.log('focusedEl: ' + focusedEl);
        }

        function focusPrevious() {
            if (focusedEl === 1 || !focusedEl) {
                lastFocusableEl.focus();
                focusedEl = focusableEls.length;
                //console.log('Last element focused');
            } else {
                focusedEl--;
                focusableEls[focusedEl - 1].focus();
                //console.log('Previous element focused');
            }
            //console.log('focusedEl: ' + focusedEl);
        }

    }
});
